import { useSelector } from 'react-redux';

export const formatNumber = (value, fractionDigits, decimalSeparator, thousandsSeparator) =>
  value
    .toFixed(fractionDigits)
    .replace('.', decimalSeparator)
    .replace(/^[+-]?\d+/, function (int) {
      return int.replace(/(\d)(?=(\d{3})+$)/g, `$1${thousandsSeparator}`);
    });

export const useFormattedNumber = (value) => {
  const { languageSettings } = useSelector((state) => state.configurator.configuration.information);
  const { decimalpoint, pricedecimals, thousandsseparator } = languageSettings;
  return formatNumber(value, pricedecimals, decimalpoint, thousandsseparator);
};

export const useFormattedPrice = (value) => {
  const { languageSettings, channelSettings } = useSelector(
    (state) => state.configurator.configuration.information
  );
  const { currencysymbolposition } = languageSettings;
  const { currencySymbol } = channelSettings;
  const number = useFormattedNumber(value);
  return currencysymbolposition === 'left' ? `${currencySymbol}${number}` : `${number} ${currencySymbol}`;
};
